<template>
  <div class="st-tabs">
    <div class="st-tabs__list" role="tablist" :aria-label="ariaLabel">
      <button
        v-for="tab in tabs"
        :key="tab.type"
        class="st-tabs__list__tab"
        :class="{ 'st-tabs__list__tab--is-active': isActiveTab(tab.type) }"
        role="tab"
        :aria-selected="isActiveTab(tab.name)"
        :aria-controls="`${tab.type}-tabb`"
        :id="`st-tab-${tab.type}`"
        tabindex="0"
        @click="switchTab(tab.type)"
      >
        <span class="st-tabs__list__tab__name">{{ capitalize(tab.name) }}</span>
      </button>
    </div>
    <div class="st-tabs__dropdown">
      <h1 class="st-tabs__dropdown__heading">{{ title }}</h1>
      <st-select
        :items="tabs"
        :value="activeTab"
        @change="(val) => switchTab(val)"
        tabindex="0"
        :has-empty="false"
      />
    </div>
    <div class="st-tabs__content">
      <template v-for="tab in tabs">
        <div
          :key="tab.type"
          class="st-tabs__content__slot"
          role="tabpanel"
          :id="`${tab.type}-tabb`"
          :aria-labelledby="`st-tab-${tab.type}`"
          v-if="tab.type === activeTab"
        >
          <slot :name="tabSlotName"></slot>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { capitalize } from "../../helpers";
import StSelect from "../select/Select.vue";
export default {
  name: "st-tabs",
  components: {
    StSelect,
  },
  props: {
    tabs: Array,
    initialTab: String,
    ariaLabel: {
      type: String,
      required: true,
    },
    switchTab: Function,
    activeTab: String,
    title: String,
  },
  computed: {
    tabSlotName() {
      return `tab-${this.activeTab}`;
    },
  },
  methods: {
    isActiveTab(name) {
      return name === this.activeTab;
    },
    capitalize(s) {
      return capitalize(s);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";

.st-tabs {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  font-family: $source-sans-pro;
  color: $dark-grey;
  &__list {
    display: none;
    @include large {
      display: flex;
    }
    line-height: rem-calc(18);
    border-bottom: $border-width--thin solid $light-grey;
    margin-bottom: rem-calc(16);
    &__tab {
      background: none;
      box-shadow: none;
      border: none;
      font-family: inherit;
      color: inherit;
      padding: 0 rem-calc(15);
      cursor: pointer;
      &:not(:last-child) {
        margin-right: rem-calc(15);
      }
      &:focus {
        background: $bright-orange;
        outline: none;
        & > .st-tabs__list__tab__name {
          border-bottom: $border-width solid $orange;
        }
      }
      &:hover {
        background: $light-orange;
      }
      &__name {
        display: flex;
        font-size: rem-calc(14);
        height: rem-calc(28);
        line-height: rem-calc(29);
        border-bottom: $border-width solid transparent;
      }
      &--is-active {
        > .st-tabs__list__tab__name {
          font-weight: 600;
          border-color: $orange;
        }
      }
    }
  }
  &__dropdown {
    display: flex;
    flex-direction: column;
    margin-bottom: rem-calc(15);
    @include large {
      display: none;
    }
    &__heading {
      margin-bottom: rem-calc(15);
      font-size: rem-calc(24);
    }
  }
}
</style>
